module.exports = __webpack_public_path__ + "static/blog81-0e7a3a563921db7aab05e1e3e86559d7.png";